import { render, staticRenderFns } from "./DHLReturnShowBlock.vue?vue&type=template&id=6493de21"
import script from "./DHLReturnShowBlock.vue?vue&type=script&lang=js"
export * from "./DHLReturnShowBlock.vue?vue&type=script&lang=js"
import style0 from "./DHLReturnShowBlock.vue?vue&type=style&index=0&id=6493de21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports